import { useNavigate, useLocation } from 'react-router-dom';

/**
 * "Voltar" que usa o histórico real do browser (`navigate(-1)`) em vez de um
 * `navigate('/rota/fixa')` — preserva `?page=`/filtros da lista de origem sem
 * a tela de detalhe precisar conhecê-los
 * (primum-core-root/docs/plans/done/admin-dashboard-pagination-url-sync.md).
 *
 * @param fallbackTo rota usada quando não há entrada anterior no histórico do
 * react-router (link de detalhe aberto direto, refresh, nova aba) — nesses
 * casos `navigate(-1)` sairia do app ou pra lugar errado.
 */
export function useBackNavigate(fallbackTo: string) {
  const navigate = useNavigate();
  const location = useLocation();

  return () => {
    if (location.key !== 'default') navigate(-1);
    else navigate(fallbackTo);
  };
}
